import { Patient } from "@/Common/Models/Patient/Patient";

class WorkSafeBcAddressModel {
    public ContactPointId: string = null;
    public StreetAddress: string = "";
    public City: string = "";
    public StateLookupId?: string = null;
    public CountryLookupId?: string = null;
    public ZipCode: string = "";

    public constructor(init?: Partial<WorkSafeBcAddressModel>) {
        this.updateAddressModel(init);
    }

    public updateAddressModel(init?: Partial<WorkSafeBcAddressModel>): WorkSafeBcAddressModel {
        Object.assign(this, init);
        return this;
    }

    public static fromPatient(patient: Patient): WorkSafeBcAddressModel {
        const preferredAddress = patient?.Addresses.firstPreferredOrDefault(x => x.IsPreferred);

        return new WorkSafeBcAddressModel({
            ContactPointId: preferredAddress?.ContactPoint_id,
            StreetAddress: preferredAddress?.StreetAddress ?? "",
            City: preferredAddress?.City,
            StateLookupId: patient?.GetStateLookupId(),
            CountryLookupId: patient?.GetCountryLookupId(),
            ZipCode: preferredAddress?.ZipCode ?? ""
        });
    }
}

export { WorkSafeBcAddressModel };
